/* cSpell:ignore INFOBOX MAPTYPE NEWENERGY Pano */
/*global BMap BMapLib*/
/*global  BMAP_MAPTYPE_CONTROL_MAP BMAP_ANCHOR_TOP_RIGHT BMAP_ANCHOR_BOTTOM_RIGHT INFOBOX_AT_TOP */

import { myConst, myFn, myMap } from "@/config/";
import { makeMarkerHtml } from "@/components/Map/utils/marker";

import { DATA_TYPE_CONFIG } from "@/utils/dataType";
import { browserInfo } from "@/utils/browserHandle";

const { $$ } = myFn;

export function initInfoBox() {
    // 初始化弹窗组件
    myMap.infoBox = new BMapLib.InfoBox(myMap.map, myConst.infoHtml, {
        enableMassClear: false,
        enableAutoPan: true,
        align: INFOBOX_AT_TOP,
        offset: new BMap.Size(0, 40), // 窗口网上移动 三角形的偏移量
        boxStyle: {
            width: "200px",
            // background: "#ccc",
            // textAlign: 'center'
        },
        boxClass: "infoBoxWrap",
        closeIconMargin: "1px 11px 0 0", // 11 是计算了 infoBoxWrap 的 padding边框 0px偏移量  10+0+1
        closeIconUrl: './static/img/close.png',
    });
    myMap.infoBox.addEventListener('close', event => {
        toggleInfoBox({ on_off: false, source: 'close event' });
    });
}

export function openInfoBox(v) {
    // 去掉上一次点击请求成功的 橙色背景 当前 label 着色
    document.querySelectorAll("#map .marker_icon.__sele__").forEach(elm => {
        elm.classList.remove('__sele__');
        elm.classList.add('{{selected}}');
    });
    const seleHtml = v.label.getContent().replace('{{selected}}', '__sele__');
    v.label.setContent(seleHtml);

    // 先打开才会有 infoBox Dom
    // infoBox.setContent 只有 open 有 Dom 才有效 内部实现是innerHTML 还不如自己 gId 修改优化
    myMap.infoBox.open(v.bLoc);
    myMap.infoBoxState.lastOpen = Date.now();
    myMap.infoBoxState.openMarker = v;

    // 打开后删除顶部为了 pin 撑开的 padding 空间 防止marker上方的地图点击无效
    // 每次 infoBox 被关闭 Dom会被删除 所以没关系
    document.querySelector(".infoBoxWrap").style.paddingTop = 0;
    // 先显示，避免之前隐藏后 连续打开 infoBox
    $$("#infoBox").removeClass("loading");
    // 打开啊 infobox 后判断是否覆盖 地图中心图标(棒棒糖)，如果覆盖则隐藏
    $$("#marker_center").hide();

    // 清空 infoBox 里面的数据 如果未关闭上一个的直接打开新的，会使用上一次打开的infoBox Dom
    infoBoxHtmlHandle("delete");
    // 先显示名字 免得走 getItem 名字都要等半天
    // 除了微信的移动端都唤起 App 进行导航
    const _encodeName = encodeURIComponent(v.name);
    const _query = `location=${v.lat},${v.lng}&title=${_encodeName}&content=${_encodeName}&src=${location.hostname}`;
    if (!myConst.isMobile || !browserInfo.versions.weixin) {
        $$("#infoBox_name")[0].innerHTML = `<a target="_blank" href="http://api.map.baidu.com/marker?${_query}&output=html">${v.name}</a>`;
    } else {
        $$("#infoBox_name")[0].innerHTML = `<a target="_blank" href="bdapp://map/marker?${_query}&traffic=on">${v.name}</a>`;

    }

    const thisTime = Date.now() - myConst.updateTimeout;
    // 超过时间则更新 否则使用本地数据
    if ((v.lastUpdate ? thisTime > v.lastUpdate : true) && DATA_TYPE_CONFIG[v.type].getDetail) {
        // ajax 修改数据
        getItem(v);
    } else {
        // 本地数据只更新 infoBox
        infoBoxHtmlHandle('modify', v);
    }
    infoBoxCoverHandle(v);
}

export function toggleInfoBox(options) {
    const on_off = options ? options.on_off : !myMap.infoBox._isOpen;
    if (on_off) {
        const v = options.detail.v;
        openInfoBox(v);
        $$("#marker_center").hide();
    } else {
        // 关闭 infoBox
        // console.log('options.source', options.source)
        myMap.infoBox.close();
        $$("#marker_center").show();
    }
}



function getItem(v) {
    $$("#infoBox").addClass("loading");
    DATA_TYPE_CONFIG[v.type].getDetail(
        { id: v.id },
    ).then(d => {
        const res = d.data.result;
        if (d.data.code !== 200) throw new Error(`请求数据错误 x502 ${d.data.msg}`);
        Object.assign(v, res);
        const html = makeMarkerHtml(v, 'getItem');
        v.label.setContent(html);
        // 如果现在打开的 infobox 还是 ajax 请求的 marker 则赋值
        if (myMap.infoBoxState.openMarker.id === v.id) {
            infoBoxHtmlHandle('modify', v);
        }
    }).catch(err => {
        if (myMap.infoBoxState.openMarker.id === v.id) {
            infoBoxHtmlHandle('fail', v);
        }
        console.red('ajax Item Detail | net err', err);
        window.mdui.snackbar({
            message: `${err.message}`,
        });
    }).finally(() => {
        $$("#infoBox").removeClass("loading");
    });
}

/**
 * @name: infoBoxHtmlHandle
 * @description: 拿到数据以后填充 InfoBox HTML 内容
 *                try catch 的 error 多半是 【点开infobox后函数未执行完 导致 querySelector 拿到 undefined 】
 * @param {type}
 * @return:
 */
function infoBoxHtmlHandle(type, vv) {
    try {
        if (type === 'delete') {
            $$("#infoBox_name")[0].innerText = '';
            document.querySelector("#infoBox_total").textContent = "";
            document.querySelector("#infoBox_empty").textContent = "";
            document.querySelector("#infoBox_tel").innerHTML = "";
            document.querySelector("#infoBox_info").innerHTML = "";
        }
        if (type === 'modify' || type === 'fail') {
            const telHtml = `<a href="tel:{{tel}}">{{tel}}</a>`;
            // 两者区别主要是在时效性的东西上 如果错误 就删掉一些时效性的东西
            if (type === 'modify') {
                document.querySelector("#infoBox_empty").textContent = vv.eCount;
                document.querySelector("#infoBox_use").textContent = vv.uCount;
                document.querySelector("#infoBox_total").textContent = vv.cCount;
            }
            if (type === 'fail') {
                document.querySelector("#infoBox_empty").textContent = " ×";
                document.querySelector("#infoBox_use").textContent = " ×";
                document.querySelector("#infoBox_total").textContent = " ×";
            }

            // 常量两者都要赋值
            document.querySelector("#infoBox_tel").innerHTML = telHtml.replace(/{{tel}}/g, vv.tel);
            try {
                const temple = myConst.infoInfoHtml;
                const info = vv.info;
                let infoHtml = "";
                if (info) {
                    info.forEach(item => {
                        infoHtml += temple.replace("{{title}}", item.k).replace("{{content}}", item.v);
                    });
                    document.querySelector("#infoBox_info").innerHTML = infoHtml;
                }
            } catch (error) {
                console.log('error', error);
                document.querySelector("#infoBox_info").innerHTML = "";
            }
        }
    } catch (error) {
        console.red('infoBoxHtmlHandle', error);
    }
}

function infoBoxCoverHandle(v) {
    if (!v.cover) {
        infoBoxCoverUsePano(v);
    } else {
        infoBoxCoverUseCover(v);
    }
}

function infoBoxCoverUseCover(v) {
    $$("#infoBox_a").attr("href", v.cover);
    $$("#infoBox_img").attr("src", v.cover);
}


function infoBoxCoverUsePano(v) {
    // 全景数据 点击图片后跳到全景
    $$("#infoBox_a").attr("href", `https://api.map.baidu.com/pano/?x=${v.lng}&y=${v.lat}&lc=0&ak=hItgwGlESMW1GTg8I0i9HewqGbGvCQNn`);
    if (!v.pano) {
        v.pano = new BMap.PanoramaService();
    }
    // 全景图片
    // 插入loading
    $$("#infoBox_img").attr("src", "./static/img/pano_loading.gif");
    if (!v.panoId) {
        // 根据单车点经纬度查找全景坐标 异步
        v.pano.getPanoramaByLocation(v.bLoc, 50, data => {
            if (data) {
                const panoId = data.id;
                v.panoId = panoId;
                // 异步拿到图片后需要判断是否还是当前打开的 openMarker
                if (myMap.infoBoxState.openMarker.id === v.id) {
                    havePano(panoId);
                }
            } else {
                v.panoId = 'not';
                notPano();
            }
        });
    } else if (v.panoId && v.panoId != 'not') {
        havePano(v.panoId);
    } else {
        notPano();
    }

    function havePano(panoId) {
        const imgUlr = `https://mapsv0.bdimg.com/?qt=pdata&sid=${panoId}&pos=1_2&z=4`;
        // const imgUlr = `http://pcsv1.map.bdimg.com/?qt=pdata&sid=${panoId}&pos=0_0&z=2`;
        $$("#infoBox_img").attr("src", imgUlr);
    }
    function notPano() {
        // 没有全景的地方
        // 恢复默认地图
        $$("#infoBox_img").attr("src", "./static/img/pano_default.png");
        $$("#infoBox_a").attr("href", "javascript:;");
    }
}

/**
 * @name: checkElmCover
 * @description: 检查两个元素是否重叠
 * @param {type}
 * @return:
 */
function checkElmCover(elm1, elm2) {
    let objOne = $$(elm1),
        objTwo = $$(elm2);
    let one = objOne.offset();
    let two = objTwo.offset();
    let oC = {
        x: one.left + one.width / 2,
        y: one.top + one.height / 2,
    };
    let tC = {
        x: two.left + two.width / 2,
        y: two.top + two.height / 2,
    };
    return Math.abs(oC.x - tC.x) <= one.width / 2 + two.width / 2 && Math.abs(oC.y - tC.y) <= one.height / 2 + two.height / 2;
}
